"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResizeHandles = exports.SnapAreas = exports.useResizerContext = exports.ResizerProvider = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./Resizer.css"));
var dynamic_1 = require("@vanilla-extract/dynamic");
var inversify_react_1 = require("inversify-react");
var mobx_react_1 = require("mobx-react");
var EditorWidgetRegistry_1 = require("../WidgetRegistry/EditorWidgetRegistry");
var CommonWidgetRegistry_1 = require("@CommonFrontend/WidgetRegistry/CommonWidgetRegistry");
var WidgetManager_1 = require("../WidgetManager");
var useSelectionState_1 = require("./useSelectionState");
var lodash_1 = require("lodash");
var CommonUtils_1 = require("@CommonFrontendBackend/Utils/CommonUtils");
var slate_1 = require("slate");
var slate_react_1 = require("slate-react");
var ResizerContext = react_1.default.createContext(undefined);
var WIDE_SIZE_RATIOS = {
    SMALL_SCREEN: 1,
    MEDIUM_SCREEN: 1.15,
    WIDE_SCREEN: 1.33,
};
var WIDE_SIZE_BREAKPOINTS = {
    MEDIUM_SCREEN: 1140,
    WIDE_SCREEN: 1440,
};
var CONTENT_WIDTH_SNAP_BUFFER = 40;
var useResizeableConfig = function (element) {
    var _a, _b;
    if ((0, EditorWidgetRegistry_1.isContainerManagedWidget)(element.type) || !(0, EditorWidgetRegistry_1.isResizeableWidget)(element)) {
        return {
            isResizingEnabledForWidget: false,
            isCustomResizingEnabledForWidget: false,
            savedWidgetWidth: undefined,
            savedWidgetHeight: undefined,
            isWideResizingEnabledForWidget: false,
            isHeightEnabledForWidget: false,
            handleDirections: undefined,
            widthConfig: undefined,
            heightConfig: undefined,
        };
    }
    var resizeConfiguration = (0, CommonWidgetRegistry_1.getTraitConfig)({ widgetType: element.type, traitName: "resizeable" });
    if (!resizeConfiguration) {
        return {
            isResizingEnabledForWidget: false,
            isCustomResizingEnabledForWidget: false,
            savedWidgetWidth: undefined,
            savedWidgetHeight: undefined,
            isWideResizingEnabledForWidget: false,
            handleDirections: undefined,
            isHeightEnabledForWidget: false,
            widthConfig: undefined,
            heightConfig: undefined,
        };
    }
    var isCustomResizingEnabledForWidget = !!resizeConfiguration.width.custom;
    var isWideResizingEnabledForWidget = !!resizeConfiguration.width.wide;
    var isHeightEnabledForWidget = !!resizeConfiguration.height;
    var savedWidgetWidth = element.data.width;
    var savedWidgetHeight = (_a = (resizeConfiguration.height ? element.data.height : undefined)) !== null && _a !== void 0 ? _a : 0;
    return {
        isResizingEnabledForWidget: true,
        isCustomResizingEnabledForWidget: isCustomResizingEnabledForWidget,
        isWideResizingEnabledForWidget: isWideResizingEnabledForWidget,
        savedWidgetWidth: savedWidgetWidth,
        savedWidgetHeight: savedWidgetHeight,
        isHeightEnabledForWidget: isHeightEnabledForWidget,
        handleDirections: resizeConfiguration.handleDirections,
        widthConfig: resizeConfiguration.width,
        heightConfig: (_b = resizeConfiguration.height) !== null && _b !== void 0 ? _b : {},
    };
};
exports.ResizerProvider = (0, mobx_react_1.observer)(function (_a) {
    var _b, _c, _d;
    var children = _a.children, mountNode = _a.mountNode, element = _a.element;
    var editor = (0, slate_react_1.useSlate)();
    var widgetManager = (0, inversify_react_1.useInjection)(WidgetManager_1.WidgetManager);
    var _e = __read((0, react_1.useState)(0), 2), editorContentWidth = _e[0], setEditorContentWidth = _e[1];
    var _f = __read((0, react_1.useState)(false), 2), supportsWideResizing = _f[0], setSupportsWideResizing = _f[1];
    var resizeAttributesRef = (0, react_1.useRef)({ startSizePx: undefined, startClickPoint: undefined, direction: undefined, initialAlignment: undefined });
    var _g = __read((0, react_1.useState)({
        isResizing: false,
        resizingWidth: undefined,
        resizingHeight: undefined,
    }), 2), resizingState = _g[0], setResizingState = _g[1];
    var _h = useResizeableConfig(element), isResizingEnabledForWidget = _h.isResizingEnabledForWidget, isWideResizingEnabledForWidget = _h.isWideResizingEnabledForWidget, isCustomResizingEnabledForWidget = _h.isCustomResizingEnabledForWidget, savedWidgetWidth = _h.savedWidgetWidth, savedWidgetHeight = _h.savedWidgetHeight, handleDirections = _h.handleDirections, isHeightEnabledForWidget = _h.isHeightEnabledForWidget, restOfResizeableConfig = __rest(_h, ["isResizingEnabledForWidget", "isWideResizingEnabledForWidget", "isCustomResizingEnabledForWidget", "savedWidgetWidth", "savedWidgetHeight", "handleDirections", "isHeightEnabledForWidget"]);
    var projectDimensionStore = (0, inversify_react_1.useInjection)("projectDimensionStore");
    var pageContentWidth = projectDimensionStore.pageContentWidth;
    var wideWidth = editorContentWidth * getWideWidthRatio(pageContentWidth);
    var widgetWidthsInPixels = (0, react_1.useMemo)(function () { return ({ wide: wideWidth, content: editorContentWidth, full: pageContentWidth }); }, [editorContentWidth, pageContentWidth, wideWidth]);
    var maxCustomWidth = editorContentWidth - CONTENT_WIDTH_SNAP_BUFFER * 2;
    var updateWidgetAlignment = (0, react_1.useCallback)(function (nextAlignment) {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("any", {
            path: widgetManager.getPath(element),
            action: "update",
            data: {
                alignment: nextAlignment,
            },
        }));
    }, [element, widgetManager]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if (mountNode && isResizingEnabledForWidget) {
            var _c = __read(slate_1.Editor.parent(editor, slate_react_1.ReactEditor.findPath(editor, element)), 1), parentNode = _c[0];
            var contextSupportsWideWidgets = isWideResizingEnabledForWidget &&
                (slate_1.Editor.isEditor(parentNode) ||
                    !!((_b = (_a = (0, EditorWidgetRegistry_1.getGenericConfigByType)(parentNode.type, true)) === null || _a === void 0 ? void 0 : _a.containerNodeConfiguration) === null || _b === void 0 ? void 0 : _b.supportWideWidgets));
            setSupportsWideResizing(contextSupportsWideWidgets);
            var nodeToFindNearestLayoutFrom = mountNode;
            if (contextSupportsWideWidgets) {
                nodeToFindNearestLayoutFrom = slate_react_1.ReactEditor.toDOMNode(editor, editor);
            }
            var anchoringLayoutElement_1 = nodeToFindNearestLayoutFrom.closest('[data-layout-node="true"]');
            if (!anchoringLayoutElement_1) {
                return;
            }
            if (typeof ResizeObserver !== "undefined") {
                var resizeObserver_1 = new ResizeObserver(function (entries) {
                    if (entries.length > 0) {
                        var _a = __read(entries, 1), layoutElementEntry = _a[0];
                        setEditorContentWidth(layoutElementEntry.contentBoxSize[0].inlineSize);
                    }
                });
                resizeObserver_1.observe(anchoringLayoutElement_1);
                return function () { return resizeObserver_1.unobserve(anchoringLayoutElement_1); };
            }
        }
    }, [isResizingEnabledForWidget, isWideResizingEnabledForWidget, mountNode]);
    (0, react_1.useEffect)(function () {
        if (!resizingState.isResizing) {
            return;
        }
        var onResizeHandleMouseUp = function () {
            resizeAttributesRef.current.startSizePx = undefined;
            resizeAttributesRef.current.startClickPoint = undefined;
            var nextWidth = calculateSnapPoint(resizingState.resizingWidth, widgetWidthsInPixels);
            if (nextWidth === "custom" || !supportsWideResizing) {
                nextWidth = (resizingState.resizingWidth / editorContentWidth) * 100;
            }
            var nextWidthInPx = undefined;
            if (typeof nextWidth === "number") {
                nextWidthInPx = resizingState.resizingWidth;
            }
            else {
                nextWidthInPx = widgetWidthsInPixels[nextWidth];
            }
            widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("any", __assign({ path: widgetManager.getPath(element), nextWidth: nextWidth, action: "resize" }, (0, CommonUtils_1.includeIf)(isHeightEnabledForWidget && resizingState.resizingHeight != undefined, {
                nextHeight: (resizingState.resizingHeight / (nextWidthInPx !== null && nextWidthInPx !== void 0 ? nextWidthInPx : 0)) * 100,
            }))));
            if ((0, EditorWidgetRegistry_1.isAlignableWidget)(element)) {
                var shouldResetLeftAlignment = element.data.alignment === "center" &&
                    resizeAttributesRef.current.initialAlignment === "left" &&
                    nextWidth !== "wide" &&
                    nextWidth !== "full";
                if (shouldResetLeftAlignment) {
                    updateWidgetAlignment("left");
                }
            }
            setResizingState({ isResizing: false, resizingWidth: undefined, resizingHeight: undefined });
            resizeAttributesRef.current.direction = undefined;
            resizeAttributesRef.current.initialAlignment = undefined;
            document.body.style.cursor = "";
        };
        document.addEventListener("mouseup", onResizeHandleMouseUp);
        return function () { return document.removeEventListener("mouseup", onResizeHandleMouseUp); };
    }, [
        editorContentWidth,
        element,
        isHeightEnabledForWidget,
        resizingState.isResizing,
        resizingState.resizingHeight,
        resizingState.resizingWidth,
        supportsWideResizing,
        updateWidgetAlignment,
        widgetManager,
        widgetWidthsInPixels,
    ]);
    (0, react_1.useEffect)(function () {
        if (!resizingState.isResizing) {
            return;
        }
        var onResizeHandleMouseMove = function (event) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var movedPx = { x: 0, y: 0 };
            switch (resizeAttributesRef.current.direction) {
                case "e": {
                    movedPx.x = event.clientX - resizeAttributesRef.current.startClickPoint.x;
                    break;
                }
                case "w": {
                    movedPx.x = resizeAttributesRef.current.startClickPoint.x - event.clientX;
                    break;
                }
                case "ne": {
                    movedPx.x = event.clientX - resizeAttributesRef.current.startClickPoint.x;
                    movedPx.y = resizeAttributesRef.current.startClickPoint.y - event.clientY;
                    break;
                }
                case "se": {
                    movedPx.x = event.clientX - resizeAttributesRef.current.startClickPoint.x;
                    movedPx.y = event.clientY - resizeAttributesRef.current.startClickPoint.y;
                    break;
                }
                case "nw": {
                    movedPx.x = resizeAttributesRef.current.startClickPoint.x - event.clientX;
                    movedPx.y = resizeAttributesRef.current.startClickPoint.y - event.clientY;
                    break;
                }
                case "sw": {
                    movedPx.x = resizeAttributesRef.current.startClickPoint.x - event.clientX;
                    movedPx.y = event.clientY - resizeAttributesRef.current.startClickPoint.y;
                    break;
                }
            }
            var finalSizePx = {
                x: ((_b = (_a = resizeAttributesRef.current.startSizePx) === null || _a === void 0 ? void 0 : _a.x) !== null && _b !== void 0 ? _b : 0) + movedPx.x * 2,
                y: ((_d = (_c = resizeAttributesRef.current.startSizePx) === null || _c === void 0 ? void 0 : _c.y) !== null && _d !== void 0 ? _d : 0) + movedPx.y,
            };
            var minInPx = (_f = (_e = restOfResizeableConfig.widthConfig) === null || _e === void 0 ? void 0 : _e.minInPx) !== null && _f !== void 0 ? _f : 48;
            var minWidth = isCustomResizingEnabledForWidget ? minInPx : widgetWidthsInPixels.content;
            var clampedWidth = 0;
            if (supportsWideResizing) {
                clampedWidth = Math.max(finalSizePx.x, minWidth);
            }
            else {
                var maxWidth = editorContentWidth;
                clampedWidth = (0, lodash_1.clamp)(finalSizePx.x, minWidth, maxWidth);
            }
            var minHeight = (_h = (_g = restOfResizeableConfig.heightConfig) === null || _g === void 0 ? void 0 : _g.minInPx) !== null && _h !== void 0 ? _h : 48;
            var clampedHeight = Math.max(minHeight, finalSizePx.y);
            setResizingState({ isResizing: true, resizingWidth: clampedWidth, resizingHeight: clampedHeight });
            if ((0, EditorWidgetRegistry_1.isAlignableWidget)(element)) {
                var shouldForceCenterAlignment = clampedWidth > editorContentWidth && element.data.alignment === "left";
                var shouldResetLeftAlignment = clampedWidth <= editorContentWidth &&
                    element.data.alignment === "center" &&
                    resizeAttributesRef.current.initialAlignment === "left";
                if (shouldForceCenterAlignment) {
                    updateWidgetAlignment("center");
                }
                else if (shouldResetLeftAlignment) {
                    updateWidgetAlignment("left");
                }
            }
        };
        document.addEventListener("mousemove", onResizeHandleMouseMove);
        return function () { return document.removeEventListener("mousemove", onResizeHandleMouseMove); };
    }, [
        editorContentWidth,
        element,
        isCustomResizingEnabledForWidget,
        resizingState.isResizing,
        (_b = restOfResizeableConfig.heightConfig) === null || _b === void 0 ? void 0 : _b.minInPx,
        (_c = restOfResizeableConfig.widthConfig) === null || _c === void 0 ? void 0 : _c.minInPx,
        supportsWideResizing,
        updateWidgetAlignment,
        widgetManager,
        widgetWidthsInPixels,
    ]);
    var contextValue = { resizingEnabled: false };
    if (isResizingEnabledForWidget && (isCustomResizingEnabledForWidget || supportsWideResizing)) {
        var widgetWidthInPixels_1 = typeof savedWidgetWidth === "string"
            ? widgetWidthsInPixels[savedWidgetWidth]
            : (savedWidgetWidth / 100) * editorContentWidth;
        var activeWidthInPixels = (_d = (resizingState.isResizing ? resizingState.resizingWidth : widgetWidthInPixels_1)) !== null && _d !== void 0 ? _d : 0;
        var activeHeightInPixels_1 = resizingState.isResizing
            ? resizingState.resizingHeight
            : (savedWidgetHeight / 100) * activeWidthInPixels;
        var handlers = {
            onResizeHandleMouseDown: function (event, direction) {
                event.preventDefault();
                resizeAttributesRef.current.direction = direction;
                resizeAttributesRef.current.startSizePx = { x: widgetWidthInPixels_1 !== null && widgetWidthInPixels_1 !== void 0 ? widgetWidthInPixels_1 : 0, y: activeHeightInPixels_1 !== null && activeHeightInPixels_1 !== void 0 ? activeHeightInPixels_1 : 0 };
                resizeAttributesRef.current.startClickPoint = { x: event.clientX, y: event.clientY };
                if ((0, EditorWidgetRegistry_1.isAlignableWidget)(element)) {
                    resizeAttributesRef.current.initialAlignment = element.data.alignment;
                }
                if (["ne", "sw"].includes(direction)) {
                    document.body.style.cursor = "nesw-resize";
                }
                else if (["nw", "se"].includes(direction)) {
                    document.body.style.cursor = "nwse-resize";
                }
                else {
                    document.body.style.cursor = "ew-resize";
                }
                setResizingState({
                    isResizing: true,
                    resizingWidth: widgetWidthInPixels_1,
                    resizingHeight: activeHeightInPixels_1,
                });
            },
        };
        var snapPoint = calculateSnapPoint(activeWidthInPixels, widgetWidthsInPixels);
        var showSnapAreas = resizingState.isResizing &&
            supportsWideResizing &&
            (!isCustomResizingEnabledForWidget || activeWidthInPixels >= maxCustomWidth);
        contextValue = {
            resizingEnabled: true,
            widths: widgetWidthsInPixels,
            handlers: handlers,
            styles: {
                widthConstrainingElement: __assign({ width: "".concat(activeWidthInPixels, "px") }, (0, CommonUtils_1.includeIf)(!!savedWidgetHeight, {
                    height: "".concat(activeHeightInPixels_1, "px"),
                })),
            },
            snapPoint: snapPoint,
            savedWidth: savedWidgetWidth,
            customWidthEnabled: isCustomResizingEnabledForWidget,
            showSnapAreas: showSnapAreas,
            isResizing: resizingState.isResizing,
            handleDirections: handleDirections,
        };
    }
    return react_1.default.createElement(ResizerContext.Provider, { value: contextValue }, children(contextValue));
});
var getWideWidthRatio = function (pageContentWidth) {
    if (pageContentWidth <= WIDE_SIZE_BREAKPOINTS.MEDIUM_SCREEN) {
        return WIDE_SIZE_RATIOS.SMALL_SCREEN;
    }
    if (pageContentWidth <= WIDE_SIZE_BREAKPOINTS.WIDE_SCREEN) {
        return WIDE_SIZE_RATIOS.MEDIUM_SCREEN;
    }
    return WIDE_SIZE_RATIOS.WIDE_SCREEN;
};
var useResizerContext = function () {
    var context = react_1.default.useContext(ResizerContext);
    if (!context) {
        throw new Error("Cannot call useResizerContext outside of a ResizerProvider");
    }
    return context;
};
exports.useResizerContext = useResizerContext;
var useResizerEnabledContext = function () {
    var resizerContext = (0, exports.useResizerContext)();
    if (!resizerContext.resizingEnabled) {
        throw new Error("Cannot call useResizerEnabledContext in a non-resizeable context. Use useResizerContext instead.");
    }
    return resizerContext;
};
var SNAP_GAP = 16;
exports.SnapAreas = (0, mobx_react_1.observer)(function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var projectDimensionStore = (0, inversify_react_1.useInjection)("projectDimensionStore");
    var pageContentWidth = projectDimensionStore.pageContentWidth;
    var resizerContext = useResizerEnabledContext();
    var snapPoint = resizerContext.snapPoint, showSnapAreas = resizerContext.showSnapAreas;
    var _h = resizerContext.widths, wideWidth = _h.wide, contentWidth = _h.content;
    return (react_1.default.createElement("div", { contentEditable: false },
        react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.resizeableSnapArea({
                highlighted: snapPoint === "full",
                visible: showSnapAreas,
            }), styles.snapAreaFull), style: __assign({}, (0, dynamic_1.assignInlineVars)((_a = {},
                _a[styles.snapAreaWidth] = "".concat(pageContentWidth / 2 - wideWidth / 2 - SNAP_GAP, "px"),
                _a[styles.snapAreaXOffset] = "-".concat(pageContentWidth / 2 - contentWidth / 2, "px"),
                _a))) }),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.resizeableSnapArea({
                highlighted: snapPoint === "wide",
                visible: showSnapAreas,
            }), styles.snapAreaWide), style: (0, dynamic_1.assignInlineVars)((_b = {},
                _b[styles.snapAreaWidth] = "".concat((wideWidth - contentWidth) / 2 - SNAP_GAP, "px"),
                _b[styles.snapAreaXOffset] = "-".concat((wideWidth - contentWidth) / 2, "px"),
                _b)) }),
        resizerContext.customWidthEnabled ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.resizeableSnapArea({
                    highlighted: snapPoint === "content",
                    visible: showSnapAreas,
                }), styles.resizeableSnapAreaContentStart), style: (0, dynamic_1.assignInlineVars)((_c = {}, _c[styles.snapAreaWidth] = "".concat(CONTENT_WIDTH_SNAP_BUFFER, "px"), _c)) }),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.resizeableSnapArea({
                    highlighted: snapPoint === "content",
                    visible: showSnapAreas,
                }), styles.resizeableSnapAreaContentEnd), style: (0, dynamic_1.assignInlineVars)((_d = {}, _d[styles.snapAreaWidth] = "".concat(CONTENT_WIDTH_SNAP_BUFFER, "px"), _d)) }))) : (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.resizeableSnapArea({
                highlighted: snapPoint === "content",
                visible: showSnapAreas,
            }), styles.resizableSnapAreaContent), style: (0, dynamic_1.assignInlineVars)((_e = {}, _e[styles.snapAreaWidth] = "".concat(contentWidth, "px"), _e)) })),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.resizeableSnapArea({
                highlighted: snapPoint === "wide",
                visible: showSnapAreas,
            }), styles.snapAreaWide), style: (0, dynamic_1.assignInlineVars)((_f = {},
                _f[styles.snapAreaXOffset] = "".concat(contentWidth + SNAP_GAP, "px"),
                _f[styles.snapAreaWidth] = "".concat((wideWidth - contentWidth) / 2 - SNAP_GAP, "px"),
                _f)) }),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.resizeableSnapArea({
                highlighted: snapPoint === "full",
                visible: showSnapAreas,
            }), styles.snapAreaFull), style: (0, dynamic_1.assignInlineVars)((_g = {},
                _g[styles.snapAreaXOffset] = "".concat(contentWidth + (wideWidth - contentWidth) / 2 + SNAP_GAP, "px"),
                _g[styles.snapAreaWidth] = "".concat(pageContentWidth / 2 - wideWidth / 2 - SNAP_GAP, "px"),
                _g)) })));
});
var calculateSnapPoint = function (width, widths) {
    if (width < widths.content - CONTENT_WIDTH_SNAP_BUFFER * 2) {
        return "custom";
    }
    else if (width <= widths.content + SNAP_GAP * 2) {
        return "content";
    }
    else if (width <= widths.wide + SNAP_GAP * 2) {
        return "wide";
    }
    return "full";
};
var ResizeHandles = function (_a) {
    var _b;
    var element = _a.element, show = _a.show;
    var _c = useResizerEnabledContext(), handlers = _c.handlers, savedWidth = _c.savedWidth, isResizing = _c.isResizing, handleDirections = _c.handleDirections;
    var selection = (0, useSelectionState_1.useSelectionState)(element);
    var shouldInset = savedWidth === "full";
    var handleState = "idle";
    if (isResizing || selection.widgetSelectionState === "circle") {
        handleState = "active";
    }
    else if (show) {
        handleState = "hover";
    }
    var selectionRingContentOffset = handleDirections === "ew" ? 4 : 0;
    return (react_1.default.createElement("div", { contentEditable: false, style: (0, dynamic_1.assignInlineVars)((_b = {}, _b[styles.resizeHandleSelectionRingOffset] = "".concat(selectionRingContentOffset, "px"), _b)) }, handleDirections === "ew" ? (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { onMouseDown: function (e) { return handlers.onResizeHandleMouseDown(e, "w"); }, className: styles.resizeHandle({ position: "left", state: handleState, inset: shouldInset }) }),
        react_1.default.createElement("div", { onMouseDown: function (e) { return handlers.onResizeHandleMouseDown(e, "e"); }, className: styles.resizeHandle({ position: "right", state: handleState, inset: shouldInset }) }))) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { onMouseDown: function (event) { return handlers.onResizeHandleMouseDown(event, "nw"); }, className: styles.resizeHandle({
                state: handleState,
                position: "topLeft",
                inset: shouldInset,
            }) }),
        react_1.default.createElement("div", { onMouseDown: function (event) { return handlers.onResizeHandleMouseDown(event, "ne"); }, className: styles.resizeHandle({
                state: handleState,
                position: "topRight",
                inset: shouldInset,
            }) }),
        react_1.default.createElement("div", { onMouseDown: function (event) { return handlers.onResizeHandleMouseDown(event, "sw"); }, className: styles.resizeHandle({
                state: handleState,
                position: "bottomLeft",
                inset: shouldInset,
            }) }),
        react_1.default.createElement("div", { onMouseDown: function (event) { return handlers.onResizeHandleMouseDown(event, "se"); }, className: styles.resizeHandle({
                state: handleState,
                position: "bottomRight",
                inset: shouldInset,
            }) })))));
};
exports.ResizeHandles = ResizeHandles;
